import api from 'api'
import { Logout } from 'api/resources'
import * as types from 'state/mutation-types'

export const login = function ({ store, dispatch }, username, password) {
  dispatch(types.ASYNC_REQUEST)

  return api
  .login(username, password)
  .then(response => {
    console.log(response)
    dispatch(types.SET_TOKEN, response.data.data.token)
    dispatch(types.IS_LOGGED_IN)
    dispatch(types.ASYNC_SUCCESS)
  })
  .catch(response => {
    console.log('error', username, password, response)
    dispatch(types.ASYNC_FAILURE)
  })
}

export const invalidateToken = ({ dispatch, state }) => {
  return new Promise((resolve, reject) => {
    Logout.get()
    .then(response => {
      dispatch(types.INVALIDATE_TOKEN)
      resolve(response)
    })
  })
}

export const setToken = function ({ store, dispatch }, token) {
  dispatch.types(types.SET_TOKEN, token)
}



// WEBPACK FOOTER //
// ./src/vuex/auth/actions.js